import { mdiDesktopClassic } from '@mdi/js'

export default {
  title: 'CBT',
  to: 'cbt-admin',
  icon: mdiDesktopClassic,
  resource: 'CbtAdmin',
  action: 'read',
}
